'use client'

import { getFingerprint } from '@marketplace-web/session-management/audit-util'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import {
  landingPageEvent,
  HoVBottomSectionModel,
  HoVLandingPageEvent,
} from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

type Props = { data: HoVBottomSectionModel }

export const HoVBottomSection = ({ data: { title, ctaText, ctaUrl, description } }: Props) => {
  const { track } = useTracking()

  const handleOnCtaClick = async () =>
    track(
      landingPageEvent({
        event: HoVLandingPageEvent.BottomCtaClick,
        targetDetails: ctaUrl,
        deviceId: await getFingerprint(),
      }),
    )

  return (
    <section data-testid="hov__bottom-section" className="hov__bottom-section">
      <h3 className="hov__bottom-headline">{title}</h3>
      <p className="hov__bottom-description">{description}</p>
      <a
        role="button"
        href={ctaUrl}
        className="hov__bottom-cta"
        data-testid="hov__bottom-cta"
        onClick={handleOnCtaClick}
      >
        {ctaText}
      </a>
    </section>
  )
}
